export default __webpack_public_path__ + "static/media/MINIBG.4d068a84.png";